import axios from "axios";
import { Mutex } from "async-mutex";
import { getProperty } from "../../externals/PropertiesService";
import { httpOnlySecurityService } from "../../externals/iam";

axios.defaults.withCredentials = true;
const mutex = new Mutex();
let refreshFailed = false;

async function refreshToken() {
  const release = await mutex.acquire();
  if (refreshFailed) {
    throw new axios.Cancel("Refresh token failed");
  }
  try {
    await httpOnlySecurityService.refresh();
  } catch (error) {
    refreshFailed = true;
    httpOnlySecurityService.login(window.location.href);
    throw new axios.Cancel("Refresh token failed");
  } finally {
    release();
  }
}

axios.interceptors.request.use(async (config) => {
  if (httpOnlySecurityService.isTokenExpired()) {
    if (refreshFailed) {
      throw new axios.Cancel("Refresh token failed");
    }
    await refreshToken();
  }

  return config;
});

function errorUnauthorised() {
  httpOnlySecurityService.clear();
  window.location.href = `${getProperty("FRONT_END_URL")}/#/en/login`;
}

function errorAccessDenied(error, reject) {
  if (
    error.response.headers["www-authenticate"] &&
    error.response.headers["www-authenticate"] === "illegal_configuration"
  ) {
    const configError = new Error("POC_CONFIG_ERROR");

    reject(configError);
  }
  reject(error);
}

function processError(error) {
  return new Promise((resolve, reject) => {
    if (error.response.status === 401) {
      const header = error.response.headers["www-authenticate"];
      if (header === "access_expired") {
        (async () => {
          await refreshToken();
        })();
      } else errorUnauthorised();
    } else if (error.response.status === 403) {
      errorAccessDenied(error, reject);
    } else {
      reject(error);
    }
  });
}

axios.interceptors.response.use((response) => response, processError);
export default axios;
